var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { defaultColorPalette, Text, tombac } from "tombac";
import { getProductName } from "../../shared/getProductName";
import { StyledLimits } from "./StyledLimits";
var formatValue = function (type, value) {
    switch (type) {
        case "GEO":
            return value.coordinates.length + " region(s)";
        case "COUNT":
            return value;
        case "SQUARE_KM":
            return Number(Number(value).toFixed(1)) + " km²";
        case "KM":
            return Number(Number(value).toFixed(1)) + " km";
        case "DATE_RANGE":
            if (!value.from && !value.to) {
                return "None";
            }
            if (!value.from && value.to) {
                return "to ".concat(value.to);
            }
            if (!value.to && value.from) {
                return "from ".concat(value.from);
            }
            return "".concat(value.from, " \u2014 ").concat(value.to);
        default:
            return "";
    }
};
var clamp = function (min, max, value) {
    return value < min ? min : value > max ? max : value;
};
var formatRemaining = function (type, limit, usage) {
    switch (type) {
        case "COUNT":
            return formatValue(type, clamp(0, Infinity, limit - usage));
        case "KM":
        case "SQUARE_KM":
            var percent = limit === 0 ? 0 : ((limit - usage) / limit) * 100;
            return "".concat(clamp(0, 100, percent).toFixed(0), "%");
        default:
            return "";
    }
};
var formatPercentage = function (limit, usage) {
    if (isNaN(Number(usage)) || isNaN(Number(usage))) {
        return "";
    }
    return clamp(0, 100, limit === 0 ? 100 : (usage / limit) * 100) + "%";
};
var Title = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  ", "\n"])), tombac.altText({ fontSize: 12, fontWeight: "bold" }));
var LimitValue = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-shrink: 0;\n  ", "\n"], ["\n  flex-shrink: 0;\n  ", "\n"])), tombac.text({ fontSize: 12, fontWeight: 500 }));
var UsageInfo = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", ";\n  margin-top: ", ";\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", ";\n  margin-top: ", ";\n  ", "\n"])), tombac.space(1), tombac.space(2), tombac.text({ color: tombac.color("neutral", 700), fontSize: 12 }));
var UsageBar = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  height: ", ";\n  overflow: hidden;\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n  height: ", ";\n  overflow: hidden;\n"])), tombac.color("neutral", 400), tombac.unit(3), tombac.unit(6));
var UsageBarFill = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  height: 100%;\n  width: ", ";\n"], ["\n  background-color: ", ";\n  height: 100%;\n  width: ", ";\n"])), defaultColorPalette.brandGreen, function (_a) {
    var width = _a.width;
    return width;
});
export function LimitUsage(props) {
    var _a = props.limitWithUsage, schema = _a.schema, sharedWith = _a.sharedWith, limit = _a.limit, usage = _a.usage;
    return schema ? (React.createElement(StyledLimits.Popup.Item, null,
        React.createElement(Title, null,
            React.createElement("div", null, schema.label),
            React.createElement(LimitValue, null, formatValue(schema.type, limit))),
        sharedWith && (React.createElement(Text, { fontSize: 12, fontWeight: 500, variant: "secondary" },
            "Shared limit with ",
            getProductName(sharedWith))),
        usage !== null && usage !== undefined && (React.createElement(React.Fragment, null,
            React.createElement(UsageInfo, null,
                React.createElement("div", null,
                    formatValue(schema.type, usage),
                    " used"),
                React.createElement("div", null,
                    formatRemaining(schema.type, limit, usage),
                    " available")),
            React.createElement(UsageBar, null,
                React.createElement(UsageBarFill, { width: formatPercentage(limit, usage) })))))) : null;
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=LimitUsage.js.map